import { AppState } from '../../bootstrap/redux/state/AppState';

export function isAccelerationOnSiteAllowedForOwners(state: AppState) {
  return state.session && state.session.info && state.session.info.site &&
    state.session.info.site.canOwnerAccelerate !== false;
}
